module.exports = __webpack_public_path__ + "static/media/pos.936ed816.svg";